<template>
    <div style="height: 35vh;">
        <div class="text-right">
            <Button class="el-button el-button--secondary"
                :style="disableComplaintSaveAction ? 'cursor: not-allowed; opacity: 0.6;' : ''"
                @click="save">Save</Button>
        </div>
        <div class="my-15 table-with-add" style="width: 92%;">
            <div class="add-block" @click="addNewComplaint" style="margin-top: 1rem;">
                {{ $t('ADD_COMPLAINT') }}
            </div>
            <div style="max-height: 300px; overflow-y: auto;">
                <Table class="table-striped bordered mt-10" :data="mergedComplaints" highlight-current-row
                    :row-key="row => row.id ? `id-${row.id}` : `sno-${row.sno}`" lazy
                    aria-describedby="complaintDetailsTableData" height="20vh"
                    style="height: auto; display: flex; flex-direction: column; flex: 1;">
                    <TableColumn label=" " width="40">
                    </TableColumn>

                    <TableColumn v-for="(item, index) in getComplaintHeaders" :key="index" :label="item.title"
                        :width="item.width">
                        <template slot-scope="scope" style="margin-bottom: 4rem;">
                            <span class="d-block" :class="{ 'read-only-complaint': isComplaintReadOnly(scope.row) }">
                                <Select
                                    v-if="item.paramKey === 'complaint_type' && complaintReasons && complaintReasons.length"
                                    :placeholder="getInputPlaceholder(item, scope.row)" size="mini"
                                    :required="item.required" :value="getInputModel(item, scope.row)"
                                    :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                                    @input="val => setInputModel(item, scope.row, val)" popper-class="text-right"
                                    class="select-default" style="background: transparent;">
                                    <Option v-for="reason in complaintReasons" :key="reason" :value="reason"
                                        :label="reason">
                                        {{ reason }}
                                    </Option>
                                </Select>
                                <Select
                                    v-else-if="item.paramKey === 'material_code' && availableMaterials && availableMaterials.length"
                                    :placeholder="getInputPlaceholder(item, scope.row)" popper-class="text-right"
                                    class="select-default" size="mini" :required="item.required"
                                    :value="getInputModel(item, scope.row)"
                                    :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                                    @input="val => setInputModel(item, scope.row, val)" filterable allow-create
                                    default-first-option>
                                    <Option v-for="material in availableMaterials" :key="material.value"
                                        :value="material.value" :label="material.label">
                                        {{ material.label }}
                                    </Option>
                                </Select>
                                <Select
                                    v-else-if="item.paramKey === 'quantity_uom' && quantityUOM && quantityUOM.length"
                                    :placeholder="getInputPlaceholder(item, scope.row)" popper-class="text-right"
                                    class="select-default" size="mini" :required="item.required"
                                    :value="getInputModel(item, scope.row)"
                                    :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                                    @input="val => setInputModel(item, scope.row, val)" filterable allow-create
                                    default-first-option>
                                    <Option v-for="quantity in quantityUOM" :key="quantity.value"
                                        :value="quantity.value" :label="quantity.label">
                                        {{ quantity.label }}
                                    </Option>
                                </Select>
                                <Tooltip v-else-if="item.type === 'input' && item.paramKey === 'complaint_description'"
                                    :content="getInputModel(item, scope.row) || 'No description available'"
                                    :disabled="!getInputModel(item, scope.row)" placement="top" effect="dark">
                                    <Input :placeholder="getInputPlaceholder(item, scope.row)"
                                        class="input-blank p-0 bold" size="mini" :required="item.required" type="text"
                                        :value="getInputModel(item, scope.row)"
                                        :readonly="isComplaintReadOnly(scope.row)" :disabled="item.disabled"
                                        @input="val => setInputModel(item, scope.row, val)" />
                                </Tooltip>
                                <Input v-else-if="item.type === 'input'"
                                    :placeholder="getInputPlaceholder(item, scope.row)" class="input-blank p-0 bold"
                                    size="mini" :required="item.required" type="text"
                                    :value="getInputModel(item, scope.row)" :readonly="isComplaintReadOnly(scope.row)"
                                    :disabled="item.disabled" @input="val => setInputModel(item, scope.row, val)" />
                                <Attachments v-if="item.type === 'attachment'"
                                    :attachments="getFilteredAttachments(scope.row)" :multiple="true" :maxAllowed="atttachmentsLimit"
                                    @addAttachments="(file) => addAttachments(file, scope.row, scope.$index)"
                                    @removeAttachments="(file) => removeAttachments(file, scope.row, scope.$index)"
                                    :readOnly="isComplaintReadOnly(scope.row)" :smallIcons="true" :showPreview="true">
                                </Attachments>

                            </span>
                        </template>
                    </TableColumn>
                </Table>
            </div>
        </div>
    </div>
</template>

<script>
import { complaintColumns } from '@/constants/complaints';
const { complaintReasons } = require('pando-constants');
import { mapGetters } from 'vuex';
import Attachments from './Attachments';
import { cloneDeep } from 'lodash';

export default {
    props: {
        selectedConsignee: {
            type: Object,
            required: true
        },
        atttachmentsLimit: {
            type: Number,
            default: 5
        },
        customerComplaints: {
            type: Array,
            default: function () {
                return [];
            }
        },
        orderDetails: {
            type: Object,

        },
        isShipper: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Attachments,
    },
    data() {
        return {
            complaintColumns,
            complaintReasons,
            localComplaints: [],
            attachments: {},
            modifiedComplaints: [],
            selectedRows: [],
        };
    },
    watch: {
        customerComplaints(newVal) {
            const initializedComplaints = cloneDeep(newVal || []).map(function (item) {
                return Object.assign({}, item, {
                    custom_fields: item.custom_fields || {},
                    isUpdated: false,
                    savedToDb: true
                });
            });
            this.modifiedComplaints = initializedComplaints;
        },
    },
    computed: Object.assign({}, mapGetters({
        isComplaintsLoading: 'order/isComplaintsLoading',
        configurations: 'app/configurations',
    }), {
        quantityUOM() {
          return (this.configurations.complaints_quantity_uom || ['IT', 'CS']).map(item => ({
                    value: item,
                    label: item
                })
            );
        },
        availableMaterials() {
            const allMaterials = this.$store.getters['order/materials'];
            if (!allMaterials || !allMaterials.materials) {
                return [];
            }

            return allMaterials.materials.map(item => ({
                value: item.material.name,
                label: item.material.name
            })).filter(material => material.value);
        },
        // areAllRowsSelected() {
        //     return this.selectedRows.length === this.mergedComplaints.length && this.selectedRows.length > 0;
        // },
        hasEmptyFields() {
            return this.hasInvalidRows();
        },
        getComplaintHeaders() {
            let dbHeaders = [];


            const customHeaders = dbHeaders.map(item => ({
                title: item.label || item.title,
                paramKey: item.name,
                type: item.type === 'textbox' ? 'input' : item.type || 'input',
                required: item.required || false,
                width: item.width || '150px',
                disabled: item.disabled || false,
                isCustom: true
            }));

            const parentHeaders = this.complaintColumns.map(col =>
                Object.assign({}, col, { isCustom: false })
            );

            const allHeaders = [...parentHeaders, ...customHeaders];

            const nonAttachments = allHeaders.filter(h => h.type !== 'attachment');
            const attachments = allHeaders.filter(h => h.type === 'attachment');

            return [...nonAttachments, ...attachments];
        },
        disableComplaintSaveAction() {
            const hasPermission = this.$hasPermission('raise_complaints');
            const shouldDisable = !hasPermission;
            return shouldDisable;
        },
        // filteredComplaints() {
        //     if (!this.selectedConsignee || !this.selectedConsignee.location_id) {
        //         return this.modifiedComplaints;
        //     }
        //     return this.modifiedComplaints.filter(complaint =>
        //         complaint.destination_location_id === this.selectedConsignee.location_id
        //     );
        // },
        // filteredLocalComplaints() {
        //     if (!this.selectedConsignee || !this.selectedConsignee.location_id) {
        //         return this.localComplaints.filter(item => item !== null && item !== undefined);
        //     }
        //     return this.localComplaints.filter(item =>
        //         item !== null &&
        //         item !== undefined &&
        //         item.destination_location_id === this.selectedConsignee.location_id
        //     );
        // },
        // complaintsFromStore() {
        //     if (!this.customerComplaints.length) {
        //         return [];
        //     }

        //     return this.customerComplaints.map(complaint => {
        //         return Object.assign({}, complaint, {
        //             savedToDb: true,
        //             isReadOnly: true,
        //             custom_fields: complaint.custom_fields || {}
        //         });
        //     });
        // },

        mergedComplaints() {
            const localComplaints = this.localComplaints.map(complaint => {
                return Object.assign({}, complaint, {
                    savedToDb: false,
                    isReadOnly: false
                });
            });
            return localComplaints.concat(this.modifiedComplaints);

            // if (!this.selectedConsignee || !this.selectedConsignee.location_id) {
            //     const allComplaints = storeComplaints.concat(propComplaints).concat(localComplaints);
            //     return this.deduplicateComplaints(allComplaints);
            // }

            // Filter by location
            // const locationId = this.selectedConsignee.location_id;

            // const filteredStore = storeComplaints.filter(row => {
            //     const hasNoLocation = !row.destination_location_id;
            //     const matchesLocation = row.destination_location_id === locationId;
            //     return hasNoLocation || matchesLocation;
            // });

            // const filteredProps = propComplaints.filter(row => {
            //     const hasNoLocation = !row.destination_location_id;
            //     const matchesLocation = row.destination_location_id === locationId;
            //     return hasNoLocation || matchesLocation;
            // });

            // const filteredLocal = localComplaints.filter(row =>
            //     row.destination_location_id === locationId
            // );

            // const combined = filteredStore.concat(filteredProps).concat(filteredLocal);
            // const deduped = this.deduplicateComplaints(combined);

            // return localComplaints;
        }
    }),
    methods: {
        deduplicateComplaints(complaints) {
            return complaints.filter((complaint, index, arr) => {
                return arr.findIndex(c =>
                    (c.id && complaint.id && c.id === complaint.id) ||
                    (c.sno && complaint.sno && c.sno === complaint.sno)
                ) === index;
            });
        },

        isComplaintReadOnly(row) {
            if (row.sno && !row.id) {
                return this.disableComplaintSaveAction;
            }

            const result = row.isReadOnly || row.savedToDb || this.disableComplaintSaveAction;
            return result;
        },

        async fetchComplaintsFromStore() {
            try {
                if (this.orderDetails && this.orderDetails.order_number) {
                    await this.$store.dispatch('order/complaints', this.orderDetails.order_number);
                }
            } catch (error) {
                console.error('Error fetching complaints from store:', error);
            }
        },
        toggleSelectAll(event) {
            const isChecked = event.target.checked;

            if (isChecked) {
                this.selectedRows = this.mergedComplaints.filter(row => !this.isComplaintReadOnly(row));
            } else {
                this.selectedRows = [];
            }
        },
        toggleRowSelection: function (row) {
            var index = this.selectedRows.findIndex(function (selected) {
                return (row.id && selected.id === row.id) ||
                    (row.sno && selected.sno === row.sno);
            });

            if (index >= 0) {
                this.selectedRows.splice(index, 1);
            } else {
                var newSelection = {};
                for (var key in row) {
                    if (row.hasOwnProperty(key)) {
                        newSelection[key] = row[key];
                    }
                }
                newSelection._selectionKey = row.id ? 'id-' + row.id : 'sno-' + row.sno;
                this.selectedRows.push(newSelection);
            }
        },
        isRowSelected(row) {
            return this.selectedRows.some(selected =>
                (row.id && selected.id === row.id) ||
                (row.sno && selected.sno === row.sno)
            );
        },
        hasInvalidRows() {
            return this.mergedComplaints.some(row => {
                return !row.material_code || !row.complaint_type || !row.quantity;
            });
        },
        markRowUpdated(row) {
            if (!row) {
                console.warn('No row provided to mark as updated');
                return;
            }
            this.$set(row, 'isUpdated', true);
        },
        addNewComplaint() {
            if (this.disableComplaintSaveAction) {
                return;
            }
            const newRow = {
                material_code: '',
                batch_id: '',
                complaint_type: '',
                quantity: '',
                quantity_uom: '',
                complaint_description: '',
                attachment_ids: [],
                custom_fields: {},
                sno: Date.now(),
                isUpdated: true,
                savedToDb: false,
                isReadOnly: false,
                destination_location_id: this.selectedConsignee.location_id,
                destination_gate_id: this.selectedConsignee.gate_id,
                delivery_number: '',
                invoice_number: '',
                cctv_link: '',
            };

            const columns = this.getComplaintHeaders || [];
            columns.forEach(column => {
                if (column.type === 'input' && column.paramKey) {
                    if (column.isCustom) {
                        newRow.custom_fields = newRow.custom_fields || {};
                        newRow.custom_fields[column.paramKey] = '';
                    }
                }
                if (column.type === 'dropdown' && column.paramKey) {
                    if (column.isCustom) {
                        newRow.custom_fields = newRow.custom_fields || {};
                        newRow.custom_fields[column.paramKey] = [];
                    }
                }
            });

            this.localComplaints.push(newRow);
        },
        // async confirmDeleteSelectedComplaints() {
        //     if (this.selectedRows.length === 0) return;

        //     const result = await this.$PromptConfirm(
        //         `Are you sure you want to delete ${this.selectedRows.length} selected complaints?`,
        //         'Delete Selected Complaints',
        //         {
        //             confirmButtonText: 'Yes',
        //             cancelButtonText: 'No',
        //         }
        //     );

        //     if (result === 'confirm') {
        //         await this.deleteMultipleRows(this.selectedRows);
        //     }
        // },

        // async deleteMultipleRows(rows) {
        //     if (!rows || rows.length === 0) return;

        //     const rowsWithId = rows.filter(row => row.id);

        //     try {
        //         if (rowsWithId.length > 0) {
        //             const idsToDelete = rowsWithId.map(row => row.id);
        //             await this.$store.dispatch('order/bulkDeleteCustomerComplaints', idsToDelete);
        //         }

        //         rows.forEach(row => {
        //             this.removeFromAllStates(row);
        //         });

        //         this.selectedRows = [];

        //         this.$successMessage({
        //             message: `${rows.length} complaint${rows.length > 1 ? 's' : ''} deleted successfully.`,
        //         });

        //     } catch (error) {
        //         this.$errorMessage({
        //             message: 'Error deleting selected complaints: ' + error.message,
        //         });
        //     }
        // },

        // removeFromAllStates(info) {

        //     this.selectedRows = this.selectedRows.filter(
        //         selected => !((selected.id === info.id) || (selected.sno === info.sno))
        //     );


        //     this.modifiedComplaints = this.modifiedComplaints.filter(
        //         item => !this.isSameItem(item, info)
        //     );
        //     this.localComplaints = this.localComplaints.filter(
        //         item => !this.isSameItem(item, info)
        //     );
        // },
        isSameItem(a, b) {
            return (a.id && b.id && a.id === b.id) ||
                (a.sno && b.sno && a.sno === b.sno);
        },
        async save() {
            try {

                const modifiedExistingRows = Array.isArray(this.modifiedComplaints)
                    ? this.modifiedComplaints.filter(row => row.isUpdated && !this.isComplaintReadOnly(row))
                    : [];
                const filteredLocalComplaints = this.localComplaints.filter(row => !this.isComplaintReadOnly(row));
                const allChangedRows = modifiedExistingRows.concat(filteredLocalComplaints);

                if (allChangedRows.length === 0) {
                    this.$message.info('No changes to save');
                    return;
                }


                const formattedComplaints = allChangedRows.map(data => {
                    const destination_location_id = data.destination_location_id !== undefined && data.destination_location_id !== null
                        ? data.destination_location_id
                        : (this.selectedConsignee && this.selectedConsignee.location_id) || null;

                    const destination_gate_id = data.destination_gate_id !== undefined && data.destination_gate_id !== null
                        ? data.destination_gate_id
                        : (this.selectedConsignee && this.selectedConsignee.gate_id) || null;

                    // Ensure attachment_ids are properly formatted
                    let attachmentIds = [];
                    if (data.attachment_ids && Array.isArray(data.attachment_ids)) {
                        attachmentIds = data.attachment_ids.map(att => {
                            if (typeof att === 'object' && att.id) {
                                return att.id;
                            }
                            return att;
                        }).filter(id => id); // Remove null/undefined values
                    }

                    const complaint = {
                        destination_location_id: destination_location_id,
                        destination_gate_id: destination_gate_id,
                        material_code: data.material_code || '',
                        batch_id: data.batch_id || data.branch_id || '', // Handle both field names
                        quantity: data.quantity ? Number(data.quantity) : 0,
                        quantity_uom: data.quantity_uom || data.uom || '',
                        complaint_type: data.complaint_type || '',
                        complaint_description: data.complaint_description || data.remarks || '',
                        attachment_ids: attachmentIds,
                        amount: data.amount,
                        delivery_number: data.delivery_number,
                        invoice_number: data.invoice_number,
                        cctv_link: data.cctv_link,
                    };

                    if (data.id) {
                        complaint.id = data.id;
                    }

                    return complaint;
                }).filter(complaint => {
                    const isValid = complaint.destination_location_id;
                    return isValid;
                });

                if (formattedComplaints.length === 0) {
                    this.$message.warning('No valid complaints to save. Please check required fields.');
                    return;
                }

                const payload = {
                    data: formattedComplaints,
                    order_no: this.orderDetails.order_number
                };


                const result = await this.$store.dispatch('order/addCustomerComplaints', payload);
                if (result === 'Created') {
                    this.$successMessage({
                        message: 'Complaints saved successfully'
                    });

                    this.localComplaints = [];

                    this.modifiedComplaints.forEach(complaint => {
                        this.$set(complaint, 'isUpdated', false);
                    });

                    await this.fetchComplaintsFromStore();

                    this.$emit('refetch-customer-complaints');

                    this.$nextTick(() => this.$forceUpdate());
                } else if (result.data && result.data.errors) {
                    this.$errorMessage({ message: result.data.errors[0].message });
                } else {
                    let errorMessage = 'Failed to save complaints';
                    this.$errorMessage({ message: errorMessage });
                }
            } catch (error) {
                this.$errorMessage({
                    message: 'Failed to save complaints: ' + error.message
                });
                this.$nextTick(() => this.$forceUpdate());
            }
        },
        getInputPlaceholder(item, row) {
            if (item.isCustom) {
                return row.custom_fields[item.paramKey] || 'Enter ' + item.title;
            } else {
                return row[item.paramKey] || 'Enter ' + item.title;
            }
        },
        getInputModel(item, row) {
            return item.isCustom ? row.custom_fields[item.paramKey] : row[item.paramKey];
        },
        setInputModel(item, row, value) {

            if (this.isComplaintReadOnly(row)) {
                return;
            }

            let sourceRow = row;
            if (row.sno && !row.id) {
                const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
                if (localIndex >= 0) {
                    sourceRow = this.localComplaints[localIndex];
                }
            } else if (row.id) {
                const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
                if (modifiedIndex >= 0) {
                    sourceRow = this.modifiedComplaints[modifiedIndex];
                }
            }

            if (item.isCustom) {
                this.$set(sourceRow.custom_fields, item.paramKey, value);
            } else {
                this.$set(sourceRow, item.paramKey, value);
            }
            this.$set(sourceRow, 'isUpdated', true);
        },
        getFilteredAttachments(row) {
            // Handle different attachment structures
            let attachments = [];

            if (row.attachment_ids && Array.isArray(row.attachment_ids)) {
                attachments = row.attachment_ids;
            } else if (row.attachments && Array.isArray(row.attachments)) {
                attachments = row.attachments;
            }

            if (!attachments.length) {
                return [];
            }

            return attachments.map((att) => {
                // Handle different attachment object structures
                return {
                    uid: att.id || att.uid,
                    id: att.id || att.uid,
                    name: att.name || att.filename || 'Attachment',
                    url: att.attachment_url || att.url || att.file_url,
                };
            }).filter(att => att.id); // Filter out invalid attachments
        },
        async addAttachments(file, row) {
            try {
                this.markRowUpdated(row);
                const formData = new FormData();
                formData.append('attachment', file.raw);
                const result = await this.$store.dispatch('order/addAttachment', formData);

                if (result.error) {
                    this.$error({ message: result.error || this.$getErr('UPLOAD_FAILS') });
                    return;
                }

                if (!result.id || !result.attachment_url) {
                    throw new Error('Invalid response format - missing required fields');
                }

                const attachmentData = {
                    id: result.id,
                    name: file.name,
                    attachment_url: result.attachment_url,
                };

                let sourceRow = row;
                if (row.sno && !row.id) {
                    const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
                    if (localIndex >= 0) {
                        sourceRow = this.localComplaints[localIndex];
                    }
                } else if (row.id) {
                    const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
                    if (modifiedIndex >= 0) {
                        sourceRow = this.modifiedComplaints[modifiedIndex];
                    }
                }

                if (!sourceRow.attachment_ids) {
                    this.$set(sourceRow, 'attachment_ids', [attachmentData]);
                } else {
                    const newAttachmentIds = sourceRow.attachment_ids.concat([attachmentData]);
                    this.$set(sourceRow, 'attachment_ids', newAttachmentIds);
                }

                this.$set(sourceRow, 'isUpdated', true);
            } catch (err) {
                const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
                this.$error({ message: apiError || this.$getErr('UPLOAD_FAILS'), description: apiError });
            }
        },

        async removeAttachments(file, row) {
            try {
                var payload = {
                    attachment_id: file.id,
                };

                const result = await this.$store.dispatch('order/removeAttachments', payload);
                this.markRowUpdated(row);
                if (result === 'OK') {
                    // Find and update the source row
                    let sourceRow = row;
                    if (row.sno && !row.id) {
                        const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
                        if (localIndex >= 0) {
                            sourceRow = this.localComplaints[localIndex];
                        }
                    } else if (row.id) {
                        const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
                        if (modifiedIndex >= 0) {
                            sourceRow = this.modifiedComplaints[modifiedIndex];
                        }
                    }

                    // Update source row attachments
                    if (sourceRow && Array.isArray(sourceRow.attachment_ids)) {
                        this.$set(sourceRow, 'attachment_ids',
                            sourceRow.attachment_ids.filter(function (att) {
                                return att.id !== file.id;
                            })
                        );
                    }
                    this.$set(sourceRow, 'isUpdated', true);
                }
            } catch (error) {
                this.$error({ message: 'Failed to remove attachment' });
            }
        },
    }
};
</script>

<style scoped>
.table-striped.bordered.mt-10 {
    margin-bottom: 2rem;
}

.read-only-complaint {
    opacity: 0.8;
    background-color: #f8f9fa;
    border-radius: 4px;
    padding: 2px;
}

.read-only-complaint input,
.read-only-complaint .el-input__inner,
.read-only-complaint .el-select .el-input__inner {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    cursor: default !important;
    border-color: #e9ecef !important;
}

.read-only-complaint .el-select {
    pointer-events: none;
}

.read-only-checkbox {
    opacity: 0.5;
    pointer-events: none;
}

.read-only-complaint .el-input.is-disabled .el-input__inner {
    background-color: #f8f9fa !important;
    border-color: #e9ecef !important;
    color: #6c757d !important;
}

/* Readonly input styling - different from disabled */
.el-input[readonly] .el-input__inner,
.el-input__inner[readonly] {
    background-color: #f8f9fa !important;
    color: #495057 !important;
    cursor: text !important;
    border-color: #ced4da !important;
}

/* Ensure readonly inputs are still selectable for copying */
.el-input[readonly] .el-input__inner:focus,
.el-input__inner[readonly]:focus {
    border-color: #80bdff !important;
    outline: 0 !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}
</style>